(() => {
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'es-AR', {
    style: 'currency', currency: currency || 'ARS', maximumFractionDigits: 0
  }).format((Number(cents) || 0) / 100);

  function initCarousels(root = document) {
    root.querySelectorAll('[data-mt-carousel]').forEach((carousel) => {
      if (carousel.dataset.ready === 'true') return;
      carousel.dataset.ready = 'true';
      const slides = [...carousel.querySelectorAll('[data-mt-slide]')];
      const visuals = [...carousel.querySelectorAll('[data-mt-visual]')];
      const dots = [...carousel.querySelectorAll('[data-mt-dot]')];
      const counter = carousel.querySelector('[data-mt-counter]');
      if (slides.length < 2) return;
      let active = 0;
      let timer = null;
      const delay = Math.max(2500, Number(carousel.dataset.delay || 5500));
      const autoplay = carousel.dataset.autoplay === 'true';
      let touchStartX = 0;
      let touchStartY = 0;
      const labels = {
        aqua: 'AQUA TINT',
        eloise: 'LIPGLOSS',
        stay_fix: 'STAY FIX',
        gimme_bling: 'GIMME BLING',
        glam_girl: 'GLAM GIRL',
        perfect_lips: 'PERFECT LIPS'
      };

      carousel.style.setProperty('--mt-autoplay-delay', `${delay}ms`);

      const show = (index) => {
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === active);
          slide.setAttribute('aria-hidden', i === active ? 'false' : 'true');
        });
        visuals.forEach((visual, i) => {
          visual.classList.toggle('is-active', i === active);
          visual.setAttribute('aria-hidden', i === active ? 'false' : 'true');
        });
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === active);
          dot.setAttribute('aria-current', i === active ? 'true' : 'false');
        });
        const model = visuals[active]?.dataset.modelType || 'aqua';
        carousel.dataset.activeModel = model;
        carousel.dataset.activeLabel = labels[model] || 'LIP COLLECTION';
        if (counter) counter.textContent = `${String(active + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
      };

      const restartProgress = () => {
        carousel.classList.remove('is-autoplay-running');
        void carousel.offsetWidth;
        if (autoplay && !document.hidden) carousel.classList.add('is-autoplay-running');
      };

      const play = () => {
        clearTimeout(timer);
        restartProgress();
        if (!autoplay || document.hidden) return;
        timer = window.setTimeout(() => {
          show(active + 1);
          play();
        }, delay);
      };

      carousel.querySelector('[data-mt-prev]')?.addEventListener('click', () => { show(active - 1); play(); });
      carousel.querySelector('[data-mt-next]')?.addEventListener('click', () => { show(active + 1); play(); });
      dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); play(); }));
      carousel.addEventListener('touchstart', (event) => {
        const touch = event.changedTouches[0];
        if (!touch) return;
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
      }, { passive: true });
      carousel.addEventListener('touchend', (event) => {
        const touch = event.changedTouches[0];
        if (!touch) return;
        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;
        if (Math.abs(deltaX) < 46 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.15) return;
        show(active + (deltaX < 0 ? 1 : -1));
        play();
      }, { passive: true });
      document.addEventListener('visibilitychange', play);
      show(0);
      play();
    });
  }

  function initGalleries(root = document) {
    root.querySelectorAll('[data-mt-product-gallery]').forEach((gallery) => {
      const main = gallery.querySelector('[data-mt-main-image]');
      gallery.querySelectorAll('[data-mt-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (!main) return;
          main.src = thumb.dataset.src;
          main.alt = thumb.dataset.alt || '';
          gallery.querySelectorAll('[data-mt-thumb]').forEach((item) => item.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });
    });
  }

  function initEarthSpins(root = document) {
    root.querySelectorAll('.mt-lip-carousel__spin').forEach((spin) => {
      if (spin.dataset.earthSpinReady === 'true' || typeof spin.animate !== 'function') return;
      spin.dataset.earthSpinReady = 'true';
      const media = spin.closest('.mt-lip-carousel__media');
      const rawSpeed = media ? getComputedStyle(media).getPropertyValue('--mt-spin-speed').trim() : '8s';
      const seconds = Math.max(4, Number.parseFloat(rawSpeed) || 8);
      spin.animate(
        [{ transform: 'rotateY(0deg)' }, { transform: 'rotateY(360deg)' }],
        { duration: seconds * 1000, iterations: Infinity, easing: 'linear' }
      );
    });
  }

  function initProduct25d(root = document) {
    root.querySelectorAll('[data-mt-product-25d]').forEach((viewer) => {
      if (viewer.dataset.product25dReady === 'true') return;
      viewer.dataset.product25dReady = 'true';
      const stage = viewer.querySelector('.mt-product-25d');
      const product = viewer.querySelector('.mt-product-25d__product');
      if (!stage || !product) return;

      stage.classList.add('is-js-ready');
      const canDrag = viewer.dataset.drag !== 'false';
      const tilt = Number(viewer.dataset.tilt || 5);
      const seconds = Math.max(4.8, Number(viewer.dataset.speed || 8));
      const maxAngle = ['eloise', 'stay_fix', 'gimme_bling'].includes(viewer.dataset.modelType) ? 8 : 11;
      let dragging = false;
      let pointerX = 0;
      let userAngle = 0;
      let targetAngle = 0;
      const started = performance.now();

      if (canDrag) {
        stage.addEventListener('pointerdown', (event) => {
          dragging = true;
          pointerX = event.clientX;
          stage.classList.add('is-dragging');
          stage.setPointerCapture?.(event.pointerId);
        });
        stage.addEventListener('pointermove', (event) => {
          if (!dragging) return;
          targetAngle = Math.max(-maxAngle, Math.min(maxAngle, targetAngle + (event.clientX - pointerX) * .12));
          pointerX = event.clientX;
        });
        const finish = (event) => {
          dragging = false;
          targetAngle = 0;
          stage.classList.remove('is-dragging');
          stage.releasePointerCapture?.(event.pointerId);
        };
        stage.addEventListener('pointerup', finish);
        stage.addEventListener('pointercancel', finish);
        stage.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          targetAngle = event.key === 'ArrowRight' ? maxAngle : -maxAngle;
          window.setTimeout(() => { targetAngle = 0; }, 650);
        });
      }

      const animate = (now) => {
        const time = (now - started) / 1000;
        userAngle += (targetAngle - userAngle) * (dragging ? .22 : .075);
        const idle = Math.sin(time * Math.PI * 2 / seconds) * 6.5;
        const floatY = Math.sin(time * Math.PI * 2 / (seconds * .58)) * -8;
        const pitch = Math.cos(time * Math.PI * 2 / seconds) * 1.2;
        product.style.transform = `translateY(${floatY}px) rotateX(${pitch}deg) rotateY(${idle + userAngle}deg) rotateZ(${tilt}deg)`;
        requestAnimationFrame(animate);
      };
      requestAnimationFrame(animate);
    });
  }

  function initProducts(root = document) {
    root.querySelectorAll('[data-mt-product]').forEach((section) => {
      const form = section.querySelector('form[action*="/cart/add"]');
      if (!form || form.dataset.ready === 'true') return;
      form.dataset.ready = 'true';
      const quantity = form.querySelector('[name="quantity"]');
      const variantInput = form.querySelector('[name="id"]');
      const price = section.querySelector('[data-mt-price]');
      const button = form.querySelector('[name="add"]');
      const variantsNode = section.querySelector('[data-mt-variants]');
      let currentPrice = Number(section.dataset.price || 0);
      const currency = section.dataset.currency || 'ARS';

      const updateBundlePrices = () => {
        section.querySelectorAll('[data-mt-bundle]').forEach((bundle) => {
          const qty = Number(bundle.dataset.quantity || 1);
          const target = bundle.querySelector('[data-mt-bundle-price]');
          if (target) target.textContent = money(currentPrice * qty, currency);
        });
      };

      section.querySelectorAll('[data-mt-bundle]').forEach((bundle) => {
        bundle.addEventListener('click', () => {
          section.querySelectorAll('[data-mt-bundle]').forEach((item) => item.classList.remove('is-active'));
          bundle.classList.add('is-active');
          if (quantity) quantity.value = bundle.dataset.quantity || 1;
        });
      });

      if (variantsNode) {
        const variants = JSON.parse(variantsNode.textContent || '[]');
        section.querySelectorAll('[data-mt-option]').forEach((select) => {
          select.addEventListener('change', () => {
            const selected = [...section.querySelectorAll('[data-mt-option]')].map((item) => item.value);
            const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
            if (!variant) return;
            variantInput.value = variant.id;
            currentPrice = variant.price;
            if (price) price.textContent = money(variant.price, currency);
            if (button) {
              button.disabled = !variant.available;
              button.textContent = variant.available ? button.dataset.availableText : button.dataset.soldoutText;
            }
            updateBundlePrices();
          });
        });
      }
      updateBundlePrices();
    });
  }

  function initReveals(root = document) {
    const items = root.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!('IntersectionObserver' in window)) return items.forEach((item) => item.classList.add('mt-visible'));
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add('mt-visible'); observer.unobserve(entry.target); }
    }), { threshold: .12 });
    items.forEach((item) => observer.observe(item));
  }

  const init = (root = document) => { initCarousels(root); initProduct25d(root); initEarthSpins(root); initGalleries(root); initProducts(root); initReveals(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
